// extracted by mini-css-extract-plugin
export var divider = "_q4-0";
export var systemMessage = "_q4-1";